module.exports = __webpack_public_path__ + "img/CRT_Sword-003.0faf6604.png";